import { Box, Modal } from "@mui/material";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { BASE_URL } from "../../../components/BaseUrl";
import { useNavigate } from "react-router-dom";
import warning from "../../../assets/warning.svg"
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { showToast } from "../../../Utlis/messageHandler";
const PasswordNotSetModal = ({ open, onClose, email, message }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();

  const handleResend = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/account-executives/request-password-setup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
   if (!res.ok || data.error) {
      showToast(toast.error, data, t("alerts.passwordSetupFailed"));
      return;
    }
    showToast(toast.success, data, t("alerts.passwordSetupSuccess"));
      onClose();
      // navigate("/set-password"); // 👉 redirect after success
    } catch (error) {
    showToast(toast.error, error, t("alerts.passwordSetupSomethingWrong"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          px:2,
          width: 450,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Box sx={{display:"flex",justifyContent:"center"}}>
             <img src={warning} style={{width:90,height:90}}/>
        </Box>
               

        <CustomText      sx={{
            ...textStyles,
            fontSize: "24px",
            fontWeight:500,
              fontFamily: 'Poppins, sans-serif',
            color: theme.palette.tertiary.main,
            mb: 2,
            mt:1, 
            letterSpacing: "0px !important",
          }}>
          {t("passwordNotSet.title")}
        </CustomText>
        <CustomText   sx={{
            ...textStyles.body4,
            color: theme.palette.text.primary,
            mb: 3,
          }}>
       {message || t("passwordNotSet.defaultMessage")}
        </CustomText>
<Box sx={{display:"flex",justifyContent:"center"}}>
        <CustomButton
                 label={loading ? t("passwordNotSet.loading") : t("passwordNotSet.cta")}
          onClick={handleResend}
          disabled={loading}
          size='medium'
        />
        </Box>
      </Box>
    </Modal>
  );
};

export default PasswordNotSetModal;
